'use client';

import React, { useState } from 'react';
import { Toaster } from 'sonner';
import DashboardHeader from './DashboardHeader';
import ConflictAlertBanner from './ConflictAlertBanner';
import KPIBentoGrid from './KPIBentoGrid';
import SubnetUtilizationChart from './SubnetUtilizationChart';
import DeviceStatusChart from './DeviceStatusChart';
import ActivityFeed from './ActivityFeed';
import SubnetHealthTable from './SubnetHealthTable';
import NotificationHistoryWidget from './NotificationHistoryWidget';

export default function DashboardContent() {
  const [alertDismissed, setAlertDismissed] = useState(false);

  return (
    <div className="min-h-full bg-background">
      <Toaster position="bottom-right" theme="dark" richColors />
      <div className="max-w-screen-2xl mx-auto px-6 lg:px-8 xl:px-10 py-6 space-y-6">
        <DashboardHeader />
        {!alertDismissed && (
          <ConflictAlertBanner onDismiss={() => setAlertDismissed(true)} />
        )}
        <KPIBentoGrid />
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
          <div className="xl:col-span-2">
            <SubnetUtilizationChart />
          </div>
          <div>
            <DeviceStatusChart />
          </div>
        </div>
        <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
          <div className="xl:col-span-2">
            <SubnetHealthTable />
          </div>
          <div className="space-y-5">
            <ActivityFeed />
            <NotificationHistoryWidget />
          </div>
        </div>
      </div>
    </div>
  );
}